<template lang="html">
<div>
    <div :class="['list-loading',{'show':firstLoading}]">
        <van-loading class="load-icon" size="21" color="#af2d2d">加载中...</van-loading>
    </div>
</div>
</template>

<script>
export default {
    props:['firstLoading'],
    data(){
        return{

        }
    }
}
</script>

<style lang="css" scoped>

/* 加载 */

.list-loading{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    color: white;
    display: flex;
    align-items: center;
    opacity: 0;
    z-index: -1;

    transition-property: all;
    transition-duration: 0.2s;
}

.list-loading.show{
    opacity: 1;
    z-index: 1;
}

.load-icon{
    margin: 0 auto;
    margin-top: -120px;
}

.list-loading .van-loading__text{
    color: #af2d2d;
}

</style>
